<template>
  <section class="features-section getting-recruiting-section">
    <div class="container">
      <SectionHeader
        :title="data.headingDetail.title"
        :description="data.headingDetail.description"
      />
      <a-row :gutter="[40, 40]" class="feature-list">
        <a-col
          :sm="24"
          :md="12"
          :lg="8"
          v-for="(item, index) in data.features"
          :key="index"
        >
          <Card step-disabled :item="item" :index="index" />
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import Card from "../getting-started/card";
export default {
  name: "GreatFeatures",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    SectionHeader,
    Card
  },
  data() {
    return {
      title: this.data.headingDetail.title,
      description: this.data.headingDetail.description,
      features: this.data.features
    };
  }
};
</script>

<style lang="scss"></style>
